"use client"

import { create } from "zustand"

import { type AuthMeResponse } from "@/features/auth/model/auth-types"

type AuthContextState = {
  authMe: AuthMeResponse | null
  activeWorkspaceId: string | null
  activeWorkspaceSlug: string | null
  isHandlingUnauthorized: boolean
  authMeStatus: "idle" | "pending" | "success" | "error"
  authMeFetchStatus: "idle" | "fetching"
  authMeAttempted: boolean
  setAuthMe: (authMe: AuthMeResponse | null) => void
  setActiveWorkspace: (workspaceId: string | null, workspaceSlug: string | null) => void
  setHandlingUnauthorized: (value: boolean) => void
  setAuthMeStatus: (status: AuthContextState["authMeStatus"]) => void
  setAuthMeFetchStatus: (status: AuthContextState["authMeFetchStatus"]) => void
  setAuthMeAttempted: (value: boolean) => void
}

export function clearActiveWorkspacePersist() {
  useAuthContextStore.setState({ activeWorkspaceId: null, activeWorkspaceSlug: null })
}

/** Transient context derived from the backend-validated route/bootstrap result. */
export const useAuthContextStore = create<AuthContextState>()((set) => ({
    authMe: null,
    activeWorkspaceId: null,
    activeWorkspaceSlug: null,
    isHandlingUnauthorized: false,
    authMeStatus: "idle",
    authMeFetchStatus: "idle",
    authMeAttempted: false,
    setAuthMe: (authMe) => set({ authMe }),
    setActiveWorkspace: (workspaceId, workspaceSlug) =>
      set({ activeWorkspaceId: workspaceId, activeWorkspaceSlug: workspaceSlug }),
    setHandlingUnauthorized: (value) => set({ isHandlingUnauthorized: value }),
    setAuthMeStatus: (status) => set({ authMeStatus: status }),
    setAuthMeFetchStatus: (status) => set({ authMeFetchStatus: status }),
    setAuthMeAttempted: (value) => set({ authMeAttempted: value }),
}))

export function getAuthContextState() {
  return useAuthContextStore.getState()
}
